import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_DASHBOARD_REVENUE, GET_DASHBOARD_OCCUPANCY, GET_LOTS_SOLD } from "./actionTypes"
import {
  getDashboardRevenueSuccess,
  getDashboardRevenueFail,
  getDashboardOccupancySuccess,
  getDashboardOccupancyFail,
  getLotsSoldSuccess,
  getLotsSoldFail,
} from "./actions"
import {
  getDashboardRevenueReport,
  getDashboardOccupancyReport,
  getLotsSoldForDay,
} from "helpers/backend_helper"

function* fetchDashboardRevenue({ payload }) {
  try {
    const response = yield call(getDashboardRevenueReport, payload)
    if (response?.success) {
      yield put(getDashboardRevenueSuccess(response))
    } else {
      yield put(getDashboardRevenueFail(response?.message))
    }
  } catch (error) {
    yield put(getDashboardRevenueFail(error))
  }
}

function* fetchDashboardOccupancy({ payload }) {
  try {
    const response = yield call(getDashboardOccupancyReport, payload)
    if (response?.success) {
      yield put(getDashboardOccupancySuccess(response))
    } else {
      yield put(getDashboardOccupancyFail(response?.message))
    }
  } catch (error) {
    yield put(getDashboardOccupancyFail(error))
  }
}

function* fetchLotsSold() {
  try {
    const response = yield call(getLotsSoldForDay)
    if (response?.success) {
      yield put(getLotsSoldSuccess(response))
    } else {
      yield put(getLotsSoldFail(response?.message))
    }
  } catch (error) {
    yield put(getLotsSoldFail(error))
  }
}

function* dashboardSaasSaga() {
  yield takeEvery(GET_DASHBOARD_REVENUE, fetchDashboardRevenue)
  yield takeEvery(GET_DASHBOARD_OCCUPANCY, fetchDashboardOccupancy)
  yield takeEvery(GET_LOTS_SOLD, fetchLotsSold)
}

export default dashboardSaasSaga
